import React from "react";
import { Grid } from "@mui/material";
import { maxLength, minLength, NumberInput, required, TextInput } from "react-admin";

const SaveForm = () => {
  const validateName = [required(), minLength(3), maxLength(255)];
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={validateName}
        />
      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={validateName}
        />
      </Grid>
      <Grid
        item
        md={3}
        sm={6}
        xs={12}
      >
        <NumberInput
          source="studentsCapacity"
          label="Капацитет студенти"
          validate={required()}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
